// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_CriarChaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/traducoes/chave — register a key on a page.
 *
 * Idempotent upstream (upsert by page + text), so it is also the remedy for a
 * key whose machine translation never ran.
 */
import { registerContract } from './validate'

export interface Traducoes_CriarChaveInput {
pagina?: string
chave?: string
}

registerContract('Traducoes_CriarChaveInput', {
  pagina: { type: 'string',  required: false },
  chave:  { type: 'string',  required: false },
})
